/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';
import { listPageGrants } from '../sections/manageAccess/api';

export default function PageGrants() {
  const { setData } = useDataContext();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    listPageGrants()
      .then((result) => {
        setData((prev) => ({ ...prev, pageGrants: result?.grants || [] }));
      })
      .catch(() => {
        setData((prev) => ({ ...prev, pageGrants: Array.isArray(prev.pageGrants) ? prev.pageGrants : [] }));
      });
  }, [setData]);

  return null;
}
